module.exports = __webpack_public_path__ + "static/kincare-roadmapping.c29938b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/kincare/kincare-roadmapping.jpg
// module id = 469
// module chunks = 14357656358427